// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_1YVRX","flag":"index_flag_123e7","menuIcon":"index_menuIcon_18BQq"};